import MessageLogModel from "./MessageLogModel";
import ValidationItemModel from "./ValidationItemModel";

export default class AuthProviderValidationModel extends ValidationItemModel {
  name: any = { validation: null, message: new MessageLogModel() };
  requestHeaders: any = { validation: null, message: new MessageLogModel() };
}
